import styled from "styled-components";
import { Paragraph } from "../../../common";

export const TotalCount = styled(Paragraph)`
  font-size: ${({ theme }) => theme.fontSize.base};
  margin-top: 10px;
`;
